// extracted by mini-css-extract-plugin
export default {"container":"RecentlyViewedItem_module-7WWSVOI3_container__5aP0D"};